const GOAL_HASH = /^#goal-\d+$/
const HIGHLIGHT_CLASS = 'animate-goal-highlight'

export default () => ({
  init() {
    const hash = window.location.hash

    if (GOAL_HASH.test(hash)) this.$nextTick(() => this.highlight(hash))

    // iOS: tapping a push notification for a game page that's already open
    // just focuses the existing tab — no navigation/pageshow event fires —
    // so the live score can stay stale. Reload once the tab is foregrounded
    // again to pick up the latest state.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') window.location.reload()
    })
  },

  highlight(hash: string) {
    const goal = this.$el.querySelector(hash) as HTMLElement | null

    if (!goal || !goal.offsetParent) return

    goal.scrollIntoView({ behavior: 'smooth', block: 'center' })
    goal.classList.add(HIGHLIGHT_CLASS)

    goal.addEventListener(
      'animationend',
      () => goal.classList.remove(HIGHLIGHT_CLASS),
      { once: true },
    )
  },
})
